import type FrontendLogger from '../logging/FrontendLogger';

import { useContext, createContext } from 'react';

export const LoggingContext = createContext<{ logger?: FrontendLogger }>({
    logger: undefined,
});

export const useLogging = (): FrontendLogger => {
    const { logger } = useContext(LoggingContext);

    // For serverside rendering logger will not be defined, so we'll insert a placeholder
    if (!logger) {
        return {} as FrontendLogger;
    }

    return logger;
};
